// extracted by mini-css-extract-plugin
export default {"bottom":"DetailCourse_bottom__SWwUR","mb":"DetailCourse_mb__aJ3Z-"};